import React from 'react';
import { IconSvgProps } from '@models/common';

const Secure: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15 10L11.3536 13.6464C11.1583 13.8417 10.8417 13.8417 10.6464 13.6464L9 12M7.58333 3H16.4167C16.7388 3 17 3.26117 17 3.58333C17 5.19416 18.3058 6.5 19.9167 6.5H20.3333C20.7015 6.5 21 6.79848 21 7.16667V8.02527C21 13.5645 17.9969 18.6684 13.1547 21.3585L12.7764 21.5686C12.2936 21.8369 11.7064 21.8369 11.2236 21.5686L10.8453 21.3585C6.00313 18.6684 3 13.5645 3 8.02527V7.16667C3 6.79848 3.29848 6.5 3.66667 6.5H4.08333C5.69416 6.5 7 5.19416 7 3.58333C7 3.26117 7.26117 3 7.58333 3Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default Secure;
